import React from "react";
import { Info, Lightbulb, HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface InfoCard {
  title: string;
  description: string;
  icon?: "info" | "tip" | "help";
}

interface WizardStepContentProps {
  title: string;
  description: string;
  infoCards?: InfoCard[];
  children: React.ReactNode;
}

const iconMap = {
  info: Info,
  tip: Lightbulb,
  help: HelpCircle,
};

export const WizardStepContent: React.FC<WizardStepContentProps> = ({
  title,
  description,
  infoCards = [],
  children,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg sm:text-xl font-semibold">{title}</h2>
        <p className="text-muted-foreground mt-2">{description}</p>
      </div>

      {infoCards.length > 0 && (
        <div className="grid gap-4 sm:grid-cols-2">
          {infoCards.map((card, index) => {
            const IconComponent = iconMap[card.icon ?? "info"];
            return (
              <div
                key={index}
                className={cn(
                  "rounded-lg border border-input bg-muted/30 p-4",
                  "flex gap-3"
                )}
              >
                <div className="shrink-0 mt-0.5">
                  <IconComponent className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-medium text-sm">{card.title}</h3>
                  <p className="text-sm text-muted-foreground mt-1">
                    {card.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div>{children}</div>
    </div>
  );
};
